export default "__VITE_PUBLIC_ASSET__ed3a34c4__"